export default class Form {
    constructor(elm) {

        const input = elm.querySelectorAll("input, select");


        function updateInputField(inputField) {
            if (inputField.value.length == 0) {
                inputField.classList.add("input-field--empty");
                inputField.classList.remove("input-field--full");
            }
            else {
                inputField.classList.add("input-field--full");
                inputField.classList.remove("input-field--empty");
            }
        }

        input.forEach(x => {
            updateInputField(x);
            x.addEventListener("input", y => {
                x.setCustomValidity('');
                updateInputField(x);
            });
            x.addEventListener('blur', y => {
                x.classList.add('validation-activated');
            });
            x.addEventListener('invalid', y => {
                if (x.value == '') {
                    x.setCustomValidity(x.dataset.requiredText);
                    //
                } else if (x.validationMessage != x.dataset.matchText) {
                    x.setCustomValidity(x.dataset.validationText);

                }
            })
        })


        var identicalInputs = elm.querySelectorAll('[data-identical-to]');
        identicalInputs.forEach(input => {
            input.addEventListener('input', y => {
                var inputs = elm.querySelectorAll(`[data-identical-to="${input.dataset.identicalTo}"]`)
                if (inputs.length > 1) {
                    if (inputs[0].value == inputs[1].value || (inputs[0].value == '' || inputs[1].value == '')) {
                        inputs[0].setCustomValidity('');
                        inputs[1].setCustomValidity('');
                    } else {
                        input.setCustomValidity(input.dataset.matchText);
                    }
                }
            });
        });

        if (elm.querySelector('[data-component="btn-loader"]')) {
            var btn = elm.querySelector('[data-component="btn-loader"]');
            btn.addEventListener('click', e => {
                if (!btn.form.checkValidity()) {
                    btn.dispatchEvent(new Event('btn:load:done'));
                }
            });
        }

    }
}
